export const CURRENT_USER_PROFILE_CACHE_KEY = "compaire_profile_cache";

export interface CurrentUserProfileCache {
  userId: string;
  full_name: string | null;
  avatar_url: string | null;
}

const isBrowser = typeof window !== "undefined";

const normalizeCachedValue = (value: unknown): string | null => {
  return typeof value === "string" && value.trim().length > 0 ? value : null;
};

export const getCachedCurrentUserProfile = (userId?: string | null): CurrentUserProfileCache | null => {
  if (!isBrowser) return null;

  try {
    const raw = window.localStorage.getItem(CURRENT_USER_PROFILE_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<CurrentUserProfileCache> | null;
    if (!parsed || typeof parsed.userId !== "string") return null;
    if (userId && parsed.userId !== userId) return null;

    return {
      userId: parsed.userId,
      full_name: normalizeCachedValue(parsed.full_name),
      avatar_url: normalizeCachedValue(parsed.avatar_url),
    };
  } catch {
    return null;
  }
};

export const setCachedCurrentUserProfile = (profile: CurrentUserProfileCache) => {
  if (!isBrowser) return;

  window.localStorage.setItem(
    CURRENT_USER_PROFILE_CACHE_KEY,
    JSON.stringify({
      userId: profile.userId,
      full_name: profile.full_name,
      avatar_url: profile.avatar_url,
    })
  );
};

export const clearCachedCurrentUserProfile = () => {
  if (!isBrowser) return;
  window.localStorage.removeItem(CURRENT_USER_PROFILE_CACHE_KEY);
};